import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="commission-breakdown"
//
// Pop-up «Ver desglose» de la celda de comisiones de la tabla resumen `mejores`
// (ronda 18 PRD133-1). El markup es un `<dialog>` nativo cerrado
// (`_summary_table_comisiones.haml`): `showModal()` lo sube a la capa superior,
// atrapa el foco y cierra con Esc sin código propio. Aquí solo se abre, se
// cierra con los botones «Cerrar» / ✕ y se cierra al pulsar el fondo.
export default class extends Controller {
  static targets = ['dialog']

  open (event) {
    event.preventDefault()
    if (typeof this.dialogTarget.showModal === 'function') {
      this.dialogTarget.showModal()
    } else {
      this.dialogTarget.setAttribute('open', '')
    }
  }

  close (event) {
    event?.preventDefault()
    if (typeof this.dialogTarget.close === 'function') {
      this.dialogTarget.close()
    } else {
      this.dialogTarget.removeAttribute('open')
    }
  }

  // El `<dialog>` ocupa solo la caja blanca; el fondo oscuro es su `::backdrop`.
  // Un click en el fondo llega con el propio `<dialog>` como target, mientras que
  // un click dentro de la caja llega con un descendiente: así se distinguen.
  closeOnBackdrop (event) {
    if (event.target === this.dialogTarget) this.close(event)
  }
}
